// src/wsRecovery/wsResumeStore.js

/**
 * WS Resume Store
 * Keeps track of:
 *  - active channels
 *  - associated identifiers (roomName, applicantId, moduleId…)
 *  - last wsLogId received
 *
 * This store is:
 *  - in-memory
 *  - shared by all components
 *  - safe to use with socket.io (not React-dependent)
 */

// Map<channelKey, { channelKey, params, lastSeq }>
const resumeStore = new Map();

/**
 * Register a new WS channel for resume tracking.
 * Example:
 *   setResumePointer("chat:general", { roomName: "general" });
 */
export function setResumePointer(channelKey, params = {}) {
  if (!channelKey) return;

  const existing = resumeStore.get(channelKey) || {
    channelKey,
    params: {},
    lastSeq: 0
  };

  resumeStore.set(channelKey, {
    ...existing,
    params: { ...existing.params, ...params }
  });
}

export function updateResumeSeq(channelKey, wsSeq) {
  if (!channelKey || !wsSeq) return;

  const entry = resumeStore.get(channelKey);
  if (!entry) return;

  if (wsSeq > entry.lastSeq) {
    entry.lastSeq = wsSeq;
    resumeStore.set(channelKey, entry);
  }
}

/**
 * Retrieve stored info for a channel.
 */
export function getResumeInfo(channelKey) {
  return resumeStore.get(channelKey) || null;
}

/**
 * List all registered resume channels.
 */
export function listResumeChannels() {
  return Array.from(resumeStore.values());
}

/**
 * Clear all resume info (optional).
 */
export function clearResumeStore() {
  resumeStore.clear();
}